/** Hard caps for intervention cohorts (must match functions-new suggestInterventionGroups). */
export const MAX_GROUP_SIZE = 8;
export const MAX_GROUPS_PER_STUDENT = 3;

export function groupSizeError(count) {
  if (count <= MAX_GROUP_SIZE) return null;
  return `A group cannot have more than ${MAX_GROUP_SIZE} students. Split into smaller cohorts (aim for 4–6).`;
}

export function isGroupAtCapacity(count, includingSelection = false) {
  if (includingSelection) return count >= MAX_GROUP_SIZE;
  return count > MAX_GROUP_SIZE;
}
